import { memo } from "react";

import useMainNavigationPrimaryItems from "components/MainNavigation/hooks/usePrimaryItems";
import MainNavigationListItems from "components/MainNavigation/components/elements/ListItems";

const MainNavigationPrimaryItems = () => {
  const { navigationItems } = useMainNavigationPrimaryItems();

  return <MainNavigationListItems items={navigationItems} />;
};

export default memo(MainNavigationPrimaryItems);
